<template>
  <a-tooltip
    v-if="copyText"
    ref="clipboard"
    :placement="placement"
    :overlayClassName="$style.bgTooltip"
    :data-clipboard-text="copyText"
    :destroyTooltipOnHide="true"
    :getPopupContainer="getPopupContainer"
  >
    <template #title>
      <div class="copyTips" :class="$style.baseCoptyTips" v-show="tooltip">
        <icon-copy-tips />
        {{ tooltip }}
      </div>
    </template>
    <div :class="$style.iconCopy">
      <icon-copy />
    </div>
  </a-tooltip>
</template>

<script>
import { Tooltip, Icon } from "ant-design-vue";
import ClipboardJS from "clipboard";
import IconCopy from "@/assets/img/common/icon-copy.svg?inline";
import IconCopyTips from "@/assets/img/common/icon-copy-tips.svg?inline";

export default {
  name: "CopyButton",
  props: {
    copyText: [String, Number],
    placement: {
      type: String,
      default: "right"
    }
  },
  data() {
    return {
      tooltip: "",
      isVisible: false
    };
  },
  components: {
    [Tooltip.name]: Tooltip,
    [Icon.name]: Icon,
    IconCopy,
    IconCopyTips
  },
  computed: {
    showToolTip() {
      return this.tooltip !== "";
    }
  },
  mounted() {
    this.$once("hook:beforeDestroy", () => {
      this.clipboard.destroy();
    });
  },
  methods: {
    getPopupContainer(trigger) {
      return trigger.parentElement;
    },
    initClipboard() {
      const { clipboard } = this.$refs;
      this.clipboard = new ClipboardJS(clipboard.$el);
      this.clipboard.on("success", () => {
        this.tooltip = "Copied";
        setTimeout(() => {
          this.tooltip = "";
        }, 500);
      });

      this.clipboard.on("error", () => {
        this.tooltip = this.$t("Copy Error");
      });
    }
  },
  watch: {
    copyText: {
      immediate: true,
      handler(val) {
        if (val) {
          this.$nextTick(() => {
            this.initClipboard();
          });
        }
      }
    }
  }
};
</script>

<style lang="scss" module>
@import "~rfs/scss";

.iconCopy {
  @include rfs(20px, width);
  @include rfs(20px, height);

  &:hover {
    color: var(--primary);
  }

  &:focus,
  &:active {
    outline: none;
  }

  color: var(--silver);
  cursor: pointer;
}

.bgTooltip {
  // background-color: red;

  :global(.ant-tooltip-inner) {
    background-color: transparent;
    box-shadow: none;
    border-radius: 20px;
  }

  :global(.ant-tooltip-arrow) {
    &::before {
      background-color: transparent;
    }
  }
}

.baseCoptyTips {
  @include rfs(0.8rem);
  @include rfs(0.5625rem 1.0625rem, padding);

  display: flex;
  align-items: center;
  border-radius: 1.75rem;
  color: var(--legend-c-text);
  background-color: color-mix(in srgb, var(--legend-panel-bg) 80%, transparent);
  font-weight: 500;
  svg {
    @include rfs(0.625rem, margin-right);
  }
}
</style>
